// Unified shell for every public/client route. Replaces the legacy
// Layout.jsx + ExploreLayout chains.
//
// Mobile gets a fixed BottomNav with the four primary tabs
// (Explore / Favorite / Programări / Cont); main content adds a
// matching bottom pad so the bar never sits over the last row.
// Desktop hides the nav (Logo + dropdown in the header handles
// the same affordances on bigger screens).

import { Outlet, useLocation } from 'react-router-dom';
import AppHeader from './AppHeader';
import Footer from './Footer';
import BottomNav from './BottomNav';
import AppPromoBanner from '../common/AppPromoBanner';
import { isClientNativeApp, isBusinessApp } from '../../utils/platform';

export default function AppShell() {
  const location = useLocation();
  // The desktop homepage MAP view fills the viewport, so the footer is hidden
  // there (it would force a page scroll under a screen-locked map). The homepage
  // now defaults to the LIST, so the map is only the explicit ?view=map.
  const onHomeMap = location.pathname === '/'
    && new URLSearchParams(location.search).get('view') === 'map';
  return (
    // pb-20 lives on the OUTER column, NOT <main>: the fixed BottomNav has to
    // clear the WHOLE flow, and <Footer> sits AFTER <main> as a sibling. Padding
    // <main> alone pushed only main's own content up and left the footer's bottom
    // rows hidden behind the bar on mobile. iOS safe-area is handled inside
    // BottomNav; desktop hides the nav, so md:pb-0. The Business app never mounts
    // BottomNav (gated below), so it gets NO padding at any width — nesting md:pb-0
    // under pb-20 keeps them together (md:pb-0 only matters when pb-20 applies).
    <div className={`flex min-h-screen flex-col bg-cream-100 ${isBusinessApp ? '' : `pb-20 ${isClientNativeApp ? '' : 'md:pb-0'}`}`}>
      {/* Above the header, in the flow rather than fixed: it scrolls away with
          the page instead of eating viewport on every screen, and it can't fight
          BottomNav for the bottom edge. It self-gates to the mobile browsers
          Apple's Smart App Banner never reaches. */}
      <AppPromoBanner />
      <AppHeader />
      <main className="flex-1">
        <Outlet />
      </main>
      <div className={onHomeMap ? 'lg:hidden' : ''}>
        <Footer />
      </div>
      {/* CLIENT tab bar only — never mount it in the Business app (its "/" and
          shared content pages render AppShell, and it has no client nav). Gating
          at the mount keeps BottomNav's hooks/context lookups out of Business. */}
      {!isBusinessApp && <BottomNav />}
    </div>
  );
}
